import { useContext } from "react";

import { EnvironmentGroupContext } from "../contexts";

export const useEnvironmentGroup = () => {
  const environmentGroupContext = useContext(EnvironmentGroupContext);

  return {
    dispatchEnvironmentGroupsChangeEvent: environmentGroupContext.dispatchEnvironmentGroupsChangeEvent,
    dispatchEnvironmentGroupsReloadEvent: environmentGroupContext.dispatchEnvironmentGroupsReloadEvent,
    environmentGroups: environmentGroupContext.environmentGroups,
  }
}
